import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons';

import './styles.css';

const PhotoGalleryControls = props => {
  const { actions, data } = props;

  const { isSortable } = data;
  const { onChangeSortingMode } = actions;

  return (
    <>
      <div className="photo-gallery-controls">
        <div className="photo-gallery-controls__links">
          <span
            className="photo-gallery-controls__link"
            onClick={onChangeSortingMode}
          >
            <span className="photo-gallery-controls__caption">Order</span>
            {!isSortable ? (
              <FontAwesomeIcon icon={faLock} size="1x" />
            ) : (
              <FontAwesomeIcon icon={faUnlock} size="1x" />
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default PhotoGalleryControls;
